import React, { useContext, useState, useEffect } from "react";
import "./nav.css";
import Button from "@mui/material/Button";
import { ChevronDown, LayoutGrid, Headset } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { MyContext } from "../../../App";
import ClickAwayListener from "@mui/material/ClickAwayListener";

const Nav = () => {
  const [isCategoryDropdownOpen, setIsCategoryDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { categories, loadingCategories } = useContext(MyContext);
  const navigate = useNavigate();



  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // --- FIXED NAVIGATION LOGIC ---
  // This function now uses URL parameters to match your Catsliders component.
  const handleCategoryClick = (categoryId, categoryName) => {
    console.log("Navigating to category:", categoryId, categoryName);
    
    setIsCategoryDropdownOpen(false);
    
    // Create URL query parameters
    const queryParams = new URLSearchParams({
      category: categoryId,
      name: categoryName
    }).toString();
    
    // Navigate using the new URL with query parameters
    navigate(`/listing?${queryParams}`);
  };

  const renderCategories = () => {
    if (loadingCategories) {
      return (
        <div className="dropdown_menu categoryMenu">
          <div className="loading-container">
            <p>Loading categories...</p>
          </div>
        </div>
      );
    }

    if (!categories || categories.length === 0) {
      return (
        <div className="dropdown_menu categoryMenu">
          <div className="no-categories-container">
            <p>No categories available</p>
          </div>
        </div>
      );
    }

    return (
      <div className="dropdown_menu categoryMenu">
        <div className="categories-container">
          <div className="categories-list">
            <h6 className="text-g mb-3">All Categories</h6>
            <ul className="category-items">
              {categories.map((category) => (
                <li key={category._id || category.id} className="category-item">
                  <div
                    onClick={() => handleCategoryClick(category._id || category.id, category.name)}
                    className="category-link"
                    style={{ cursor: "pointer" }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#f8f9fa";
                      e.target.style.color = "#28a745";
                      e.target.style.borderColor = "#e9ecef";
                      e.target.style.transform = "translateX(4px)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.color = "#333";
                      e.target.style.borderColor = "transparent";
                      e.target.style.transform = "translateX(0)";
                    }}
                  >
                    {category.name}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="nav d-flex align-items-center">
      <div className="container-fluid">
        <div className="row position-relative">
          {!isMobile && (
            <div className="col-sm-3 part1">
              <ClickAwayListener
                onClickAway={() => setIsCategoryDropdownOpen(false)}
              >
                <div>
                  <Button
                    className="bg-g text-white catTab"
                    onClick={() => setIsCategoryDropdownOpen((prev) => !prev)}
                  >
                    <LayoutGrid className="me-2" />
                    Browse All Categories
                    <ChevronDown className="ms-2" />
                  </Button>
                  {isCategoryDropdownOpen && renderCategories()}
                </div>
              </ClickAwayListener>
            </div>
          )}

          <div className={`${isMobile ? 'col-12' : 'col-sm-7'} part2 position-static`}>
            <nav>
              <ul className="list list-inline mb-0">
                <li className="list-inline-item">
                  <Link to="/" className="nav-link">Home</Link>
                </li>
                <li className="list-inline-item">
                  <Link to="/about" className="nav-link">About</Link>
                </li>
                <li className="list-inline-item">
                  <Link to="/listing" className="nav-link">Shop</Link>
                </li>
                <li className="list-inline-item">
                  <Link to="/blog" className="nav-link">Blog</Link>
                </li>
                <li className="list-inline-item">
                  <Link to="/contacts" className="nav-link">Contact</Link>
                </li>
              </ul>
            </nav>
          </div>

          {!isMobile && (
            <div className="col-sm-2 part3 d-flex align-items-center">
              <div className="phno d-flex align-items-center ms-auto">
                <Headset className="me-2" />
                <div className="info">
                  <h5 className="text-g mb-0">9512707825</h5>
                  <p className="mb-0">24/7 Support center</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Nav;